export default __webpack_public_path__ + "static/media/dashboard.cb0e68d3.svg";